import React, {FC} from 'react';

import {Controller} from 'react-hook-form';
import {selectors, useAppSelector} from 'ui/store';

import {QuestionProps} from './Question.types';
import {getValidationRules, renderQuestion} from './Question.utils';

import './Question.scss';

const {selectSurvey} = selectors;

const Question: FC<QuestionProps> = ({name, question}) => {
    const survey = useAppSelector(selectSurvey);

    return (
        <Controller
            name={name}
            render={renderQuestion(question, survey.id)}
            rules={getValidationRules(question.type, question.validations)}
        />
    );
};
export default Question;
